<div class="ui container-home">
  <div class="ui grid">
    <div class="four  wide column  ">
      <div class="ui card filter" id='card-filter' style='background-color:rgb(249, 249, 249);'>
        <div class="content">
          <div class=" ui left floated header">Filtros
            <i class="filter icon light-blue"></i>
          </div>

        </div>

        <div class="content">
          <form [formGroup]="formDatos" id='form' class="ui form">

            <div class="field">

              <app-select-filter label="N° OT" formName="numberOT" [filters]="otFilters" (changeCheck)="setForm($event)"
                [selectedOption]="formDatos.get('numberOT')?.value"></app-select-filter>
            </div>
            <div class="field">

              <app-select-filter label="Actividad" formName="activity" [filters]="activityFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('activity')?.value"></app-select-filter>
            </div>


            <div class="field">
              <app-select-filter label="Sección" formName="section" [filters]="sectionFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('section')?.value"></app-select-filter>
            </div>
            <div class="field">
              <app-select-filter label="Código EMyR" formName="code" [filters]="codeFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('code')?.value"></app-select-filter>

            </div>
            <div class="field">
              <app-select-filter label="Nombre EMyR" formName="name" [filters]="nameFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('name')?.value"></app-select-filter>
            </div>



            <div class="field">
              <label class='label light-blue'>Estado</label>
              <div class="ui input">
                <select class="ui selection dropdown secciones" formControlName="state">
                  <option value="">Seleccione:Estado</option>
                  <option *ngFor='let n of stateFilters' [value]="n">{{n}}</option>
                </select>
              </div>
            </div>

            <div class="field">
              <label class='label light-blue'>Fecha Desde</label>
              <div class="ui input" color="accent" appearance="outline">
                <input formControlName="dateFrom" type='date' placeholder="29/03/2017">
              </div>

            </div>
            <div class="field">
              <label class='label light-blue'>Fecha Hasta</label>

              <div class="ui input" color="accent" appearance="outline">
                <input formControlName="dateUntil" type='date' placeholder="29/03/2017">
              </div>
            </div>


            <div class="field">
              <label class='label light-blue'>Resultado</label>
              <app-range [from]="from" [to]="to" (change)='onChangeEvent($event)'></app-range>
            </div>
          </form>
        </div>
        <div class="extra content">
          <button class="ui right labeled icon button button-filter primary" [disabled]='formDatos.invalid'
            (click)="aplicar()">
            <i class=" check icon"></i>
            APLICAR
          </button>
          <button class="ui right labeled icon button button-filter primary" (click)="limpiar()">
            <i class="trash alternate
                        icon"></i>
            LIMPIAR
          </button>
        </div>
      </div>
    </div>
    <div class="twelve wide column " style="justify-content:center !important;">
      <div class="ui warning message" *ngIf='listRegistros.length === 0 && !spinner  '>
        <i class="close icon"></i>
        <div class="header">
          No se encontraron registros
        </div>
      </div>
      <div class="table-scroll-container">
        <table style='margin:auto;' class="ui celled selectable table" *ngIf=' listRegistros.length> 0'>
          <thead>
            <tr>
              <th class="center aligned">
                N° OT
                <i class="caret down icon pointer" (click)="changeOrder('ot')" *ngIf="isDescending('ot')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('ot')" *ngIf="!isDescending('ot')"></i>
              </th>
              <th class="center aligned">
                Actividad
                <i class="caret down icon pointer" (click)="changeOrder('activity')"
                  *ngIf="isDescending('activity')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('activity')"
                  *ngIf="!isDescending('activity')"></i>
              </th>
              <th class="center aligned">
                Sección
                <i class="caret down icon pointer" (click)="changeOrder('section')" *ngIf="isDescending('section')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('section')" *ngIf="!isDescending('section')"></i>
              </th>

              <th class="center aligned">
                Código EMyR
                <i class="caret down icon pointer" (click)="changeOrder('code')" *ngIf="isDescending('code')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('code')" *ngIf="!isDescending('code')"></i>
              </th>

              <th class="center aligned">
                Nombre EMyR
                <i class="caret down icon pointer" (click)="changeOrder('name')" *ngIf="isDescending('name')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('name')" *ngIf="!isDescending('name')"></i>
              </th>



              <th class="center aligned">
                Estado
                <i class="caret down icon pointer" (click)="changeOrder('state')" *ngIf="isDescending('state')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('state')" *ngIf="!isDescending('state')"></i>
              </th>

              <th class="center aligned">
                Fecha
                <i class="caret down icon pointer" (click)="changeOrder('fecha')" *ngIf="isDescending('fecha')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('fecha')" *ngIf="!isDescending('fecha')"></i>
              </th>

              <th class="center aligned">
                Funcionalidad
                <i class="caret down icon pointer" (click)="changeOrder('score')" *ngIf="isDescending('score')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('score')" *ngIf="!isDescending('score')"></i>
              </th>

              <th class="center aligned">Avisos
                <i class="caret down icon pointer" (click)="changeOrder('avisos')" *ngIf="isDescending('avisos')"></i>
                <i class="caret up icon pointer" (click)="changeOrder('avisos')" *ngIf="!isDescending('avisos')"></i>
              </th>
              <th class="center aligned"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor='let item of listRegistros;index as index ;'>
              <td class="center aligned">
                {{item.Status.OT.Observed}}
              </td>
              <td class="center aligned">
                {{item.Activity_Dsc}}
              </td>
              <td class="center aligned">
                {{item.Status.Seccion?.Observed}}
              </td>
              <td class="center aligned">
                {{item.Status.CodigoEstacion?.Observed}}
              </td>
              <td class="center aligned">
                {{item.Status.DescriEstacion?.Observed}}
              </td>
              <td class="center aligned">
                <p>
                  {{item.state}}
                </p>
              </td>
              <td class="center aligned">
                {{item.When | date: 'dd/MM/yyyy' }}
              </td>
              <td class="center aligned">
                <div *ngIf="item.state!='En proceso'">
                  <app-spinner-overlay *ngIf="item.score<101 && item.score>90" class="font-optimo" [index]="index"
                    [val]="item.score" color="optimo"></app-spinner-overlay>
                  <app-spinner-overlay *ngIf="item.score<91 && item.score>70" class="font-alcanza" [index]="index"
                    [val]="item.score" color="alcanza"></app-spinner-overlay>
                  <app-spinner-overlay *ngIf="item.score<71 && item.score>40" [index]="index" [val]="item.score"
                    class="font-no-alcanza" color="no-alcanza">
                  </app-spinner-overlay>
                  <app-spinner-overlay *ngIf="item.score<41 && item.score>=0" [index]="index" [val]="item.score"
                    class="font-error" color="error">
                  </app-spinner-overlay>
                  <span *ngIf="item.score<0" class="negrita">N/A</span>

                </div>
                <div *ngIf="item.state=='En proceso'">
                  <app-spinner-overlay [index]="index" [icon]="true" class="font-gray bold">
                  </app-spinner-overlay>
                </div>
              </td>
              <td class="center aligned">
                <p>{{item.cantidadDeAvisoDeMantenimiento}}</p>
              </td>
              <td class="center aligned">
                <div class="ui vertical animated button" tabindex="0" (click)="detalle(item)">
                  <div class="hidden content">Ver </div>
                  <div class="visible content">
                    <i class="arrow right icon"></i>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ui grid" *ngIf='pages_total >0 '>
        <div class="column centered row paginacion">
          <app-paginator #paginacion [pagesTotal]='pages_total' (pageChange)='changePage($event)'>
          </app-paginator>
        </div>
      </div>
    </div>
  </div>
</div>